(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-and-save"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-product-grid')) {
    customElements.define(
      'bundle-product-grid',
      class BundleProductGrid extends HTMLElement {
        constructor() {
          super();
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }

        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        }

        refresh() {
          fetch(`${this.dataset.cartUrl}?section_id=${this.dataset.sectionId}`)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const source = html.querySelector('bundle-product-grid');
              if (source) this.innerHTML = source.innerHTML;
            })
            .catch((e) => console.error(e));
        }
      }
    );
  }

  if (!customElements.get('bundle-add-to-cart')) {
    customElements.define(
      'bundle-add-to-cart',
      class BundleAddToCart extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.onActivate.bind(this));
          this.addEventListener('keydown', (event) => {
            if (event.code === 'Enter' || event.code === 'Space') this.onActivate(event);
          });
        }

        onActivate(event) {
          const removeButton = event.target.closest('[data-remove-from-bundle]');
          if (removeButton) {
            event.preventDefault();
            event.stopPropagation();
            if (!this.classList.contains('adding')) this.removeFromCart();
            return;
          }

          event.preventDefault();
          if (this.classList.contains('adding') || this.dataset.available === 'false') return;
          this.addToCart();
        }

        removeFromCart() {
          this.classList.add('adding');

          fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.dataset.variantId, quantity: 0, sections: ['cart-icon-bubble'] }),
          })
            .then((response) => response.json())
            .then((response) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'bundle-add-to-cart',
                productVariantId: this.dataset.variantId,
                cartData: response,
              });

              this.updateCartIconBubble(response);
            })
            .catch((e) => console.error(e))
            .finally(() => this.classList.remove('adding'));
        }

        addToCart() {
          this.classList.add('adding');

          const body = JSON.stringify({
            id: this.dataset.variantId,
            quantity: 1,
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname,
          });

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body,
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                console.error(response.description || response.message);
                return;
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'bundle-add-to-cart',
                productVariantId: this.dataset.variantId,
                cartData: response,
              });

              // Update the header cart count only; never open the cart drawer from this page.
              this.updateCartIconBubble(response);

              this.classList.add('added');
              setTimeout(() => this.classList.remove('added'), 1500);
            })
            .catch((e) => console.error(e))
            .finally(() => this.classList.remove('adding'));
        }

        updateCartIconBubble(response) {
          const sectionHtml = response.sections && response.sections['cart-icon-bubble'];
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (!sectionHtml || !cartIconBubble) return;

          const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const source = html.querySelector('.shopify-section');
          if (source) cartIconBubble.innerHTML = source.innerHTML;
        }
      }
    );
  }

  if (!customElements.get('bundle-cart')) {
    customElements.define(
      'bundle-cart',
      class BundleCart extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.onClick.bind(this));
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'bundle-cart') return;
            this.refresh();
          });
        }

        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        }

        onClick(event) {
          // Keep clicks inside the widget from bubbling into page/app-level listeners that open the cart drawer.
          event.stopPropagation();

          const button = event.target.closest('[data-cart-action]');
          if (!button) return;
          event.preventDefault();

          const line = button.dataset.line;
          let quantity = parseInt(button.dataset.quantity, 10);

          if (button.dataset.cartAction === 'increase') quantity += 1;
          if (button.dataset.cartAction === 'decrease') quantity -= 1;
          if (button.dataset.cartAction === 'remove') quantity = 0;

          this.updateLine(line, quantity);
        }

        updateLine(line, quantity) {
          this.classList.add('loading');

          fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity }),
          })
            .then((response) => response.json())
            .then(() => {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-cart' });
              this.refresh();
            })
            .catch((e) => console.error(e));
        }

        refresh() {
          this.classList.add('loading');

          fetch(`${this.dataset.cartUrl}?section_id=${this.dataset.sectionId}`)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const source = html.querySelector('bundle-cart .bundle-and-save__cart-inner');
              const target = this.querySelector('.bundle-and-save__cart-inner');
              if (source && target) target.innerHTML = source.innerHTML;
            })
            .catch((e) => console.error(e))
            .finally(() => this.classList.remove('loading'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
